import _ = require("underscore");
import $ = require("jquery");
import ol = require("ol");
import Backbone = require("backbone");
import Utils = require("../utils");
import Portal = require("portal-gis");
import View = require("./view");
import Model = require("../models/base-model");

function getRootLayer(layer: Portal.MapLayerLeaf) {
    while (true) {
        let parent = Utils.extend(layer).parent;
        if (!parent) break;
        if (!parent.id) break;
        layer = parent;
    }
    return layer;
}

function touch(model: Model<any>) {
    model.set("version", (model.get("version") || 0) + 1);
}

class Tool extends View {

    static about = `controller for layerpicker-view, captures current visibility of operational layers, creates observable layer collection, binds hide and show to visibility`;

    static options = Utils.defaults({
        "view": {
            "default": "app/views/layerpicker-view",
        },
        "template": {
            "default": "app/templates/layerpicker-template",
        },
    }, View.options);

    static output = {
        "keys": {
            "about": "The layer identifiers",
        },
        "viewArgs": {
            "about": "visible:changed callback arguments containing the desired state of each layer",
        },
    };

    private get layers() {
        return this.mediator.api.layers;
    }

    execute(args = this.args) {

        _.defaults(this.options, {
            view: Tool.options.view.default,
            region: this.configuration.id,
            model: this.layers,
            template: Tool.options.template.default
        });
    }

    broadcast() {
        // experimenting with just re-rendering the entire control...it is fast enough but now the view must be stateful (to preserve toggling)
        this.mediator.on("layerloadstart", (args: {
            layer: Portal.MapLayerLeaf
        }) => {
            let layer = args.layer;
            Utils.extend(layer, { loading: true });
            layer = getRootLayer(args.layer);
            touch(this.layers.get(layer.id));
        });

        this.mediator.on("layerloadend", (args: {
            layer: Portal.MapLayerLeaf
        }) => {
            let layer = args.layer;
            Utils.extend(layer, { loading: false });
            layer = getRootLayer(args.layer);
            touch(this.layers.get(layer.id));
        });

        // once configuration has been set bind layers to view and map
        // bind the view changes to the map
        // the change event contains all layers (not just outer layers)
        this.mediator.mapView(mapView => {

            // set 'visible' attribute on every layer to match reality
            let setVisible = (layer: Portal.MapLayerLeaf) => {
                Utils.extend(layer).visible = mapView.isLayerVisible(layer.id);
                layer.Layers && layer.Layers.Layers.forEach(setVisible);
            };

            // show layer when user checks the box
            this.view.on("visible:changed", (args: { value: Rhythm.GIS.Dictionary<boolean> }) => {

                let keys = _.keys(args.value);

                keys.forEach(key => {
                    var visible = args.value[key];
                    if (visible) {
                        mapView.showLayer(key);
                    } else {
                        mapView.hideLayer(key);
                    }
                });

                this.trigger({
                    keys: keys,
                    viewArgs: args
                });

            });

            // cannot call setVisible until "map" exists on mapView
            this.mediator.mapViewMap(map => this.layers.filter(l => !l.data.disabled && !l.data.basemap).forEach(l => setVisible(l.data)));

            super.broadcast();
        });

    }
}

export = Tool;
